import { Box } from "@radix-ui/themes";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";
import { useAppStore } from "../../../../stores/RootStore";
import { AdminSensorType, DowntimesType } from "../../../../types/types";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../../ui/Separator";
import Spinner from "../../../../ui/Spinner/Spinner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../../ui/Tabs/Tabs";
import DowntimeSettingsTab from "./tabs/DowntimeSettingsTab";

const DowntimeItem = () => {
  const { id } = useParams();

  const [downtimes, setDowntimes] =
      useOutletContext<[DowntimesType[], Function]>();

  const [loading, setLoading] = useState(true);
  const [currentDowntime, setCurrentDowntime] = useState<DowntimesType>();

  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      return;
    }
    if (!downtimes) {
      navigate("/admin/downtimes");
      return;
    }
    setLoading(true);
    setCurrentDowntime(downtimes.find((downtime) => downtime.id == id));
  }, [id]);

  useEffect(() => {
    if (!currentDowntime) {
      return;
    }
    setLoading(false);
  }, [currentDowntime]);

  return loading ? (
    <Spinner />
  ) : (
    <>
      <Tabs defaultValue="settings" className="w-full h-full">
        <TabsList className="flex-none flex w-full h-12 bg-background">
          <div className="flex w-full max-w-[900px] justify-start mx-auto pl-4 pr-16">
            <TabsTrigger
              className="data-[state=active]:bg-muted data-[state=active]:text-foreground"
              value="settings"
            >
              {t("settings")}
            </TabsTrigger>
          </div>
        </TabsList>
        <Separator />
        <ScrollArea>
          <div className="flex flex-col max-w-[900px] w-full justify-start mx-auto pl-4 pr-16 relative overflow-hidden mb-20">
            <TabsContent value="settings">
              <DowntimeSettingsTab id={id} currentDowntime={currentDowntime} />
            </TabsContent>
          </div>
        </ScrollArea>
      </Tabs>
    </>
  );
};

export default DowntimeItem;
